import { dsarRetrievalViews, inputNames } from "../../constants";
const fullWidthOrHeight = () => ({
  type: '%',
  value: 100
});
const noMargins = () => ({
  margin: 0
});
const noPaddings = () => ({
  padding: 0
});
const home = {
  type: 'DsarRetrieval',
  name: 'Home View',
  id: dsarRetrievalViews.HOME,
  settings: {
    align: 'center'
  },
  children: [{
    type: 'Column',
    name: 'Form Column',
    settings: {
      width: {
        value: 50,
        type: '%'
      },
      height: {
        value: 100,
        type: '%'
      },
      margin: noMargins(),
      padding: noPaddings()
    },
    children: [{
      type: 'Row',
      name: 'Header Row',
      settings: {
        align: 'center',
        vertical: 'center',
        width: fullWidthOrHeight(),
        margin: {
          marginBottom: 20
        },
        padding: noPaddings()
      },
      children: [{
        type: 'Text',
        name: 'Small Header',
        settings: {
          text: 'See My Data Request',
          margin: {
            marginTop: 10,
            marginBottom: 10
          },
          border: {
            borderWidth: 1,
            borderColor: 'rgba(134, 134, 134, 0.33)',
            borderStyle: 'solid',
            borderTop: 'none',
            borderLeft: 'none',
            borderRight: 'none'
          },
          font: {
            fontSize: 12,
            fontWeight: '400',
            color: '#868686',
            fontFamily: 'arial, helvetica, sans-serif'
          },
          width: fullWidthOrHeight(),
          padding: {
            paddingBottom: 5
          }
        },
        children: []
      }]
    }, {
      type: 'Row',
      name: 'Brand Image Row',
      settings: {
        padding: noPaddings(),
        margin: noMargins(),
        width: {
          value: 100,
          type: '%'
        },
        align: 'center'
      },
      children: [{
        type: 'Image',
        name: 'Brand Image',
        settings: {
          height: {
            value: 90,
            type: 'px'
          }
        },
        children: []
      }]
    }, {
      type: 'Text',
      name: 'Header',
      settings: {
        margin: {
          marginTop: 10,
          marginBottom: 10
        },
        padding: noPaddings(),
        text: 'Verify Information',
        font: {
          fontSize: 21,
          fontWeight: '400',
          color: '#000000',
          fontFamily: 'arial, helvetica, sans-serif'
        },
        align: 'center',
        margin: {
          marginBottom: 30
        },
        width: {
          value: 100,
          type: '%'
        }
      },
      children: []
    }, {
      type: 'Row',
      name: 'Form Row',
      settings: {
        padding: noPaddings(),
        margin: noMargins(),
        width: {
          type: '%',
          value: 100
        },
        align: 'center'
      },
      children: [{
        type: 'Column',
        name: 'Form Column',
        settings: {
          padding: noPaddings(),
          width: 'auto',
          align: 'center',
          vertical: 'center',
          width: {
            type: '%',
            value: 100
          }
        },
        children: [{
          type: 'Text',
          name: 'Form Description',
          settings: {
            margin: {
              marginTop: 10,
              marginBottom: 10
            },
            padding: noPaddings(),
            text: 'Enter your information below to access your report',
            font: {
              fontSize: 12,
              fontWeight: '400',
              color: '#000000',
              fontFamily: 'arial, helvetica, sans-serif'
            },
            margin: {
              marginBottom: 20
            }
          },
          children: []
        }, {
          type: 'ErrorBlock',
          name: 'Form errors block',
          children: [],
          settings: {
            listItems: [],
            containerBackground: 'none',
            bulletType: 'none',
            ulFont: {
              fontSize: 12,
              fontWeight: '400',
              color: 'red',
              fontFamily: 'arial, helvetica, sans-serif'
            },
            ulPadding: noPaddings(),
            containerPadding: noPaddings(),
            containerAlign: 'center'
          }
        }, {
          type: 'Column',
          name: 'Form Column',
          settings: {
            width: {
              type: 'px',
              value: 370
            },
            align: 'center'
          },
          children: [{
            type: 'Row',
            name: 'Request ID Input Row',
            settings: {
              margin: {
                marginBottom: 20
              },
              padding: noPaddings(),
              width: {
                value: 70,
                type: '%'
              }
            },
            children: [{
              id: 'request-id',
              type: 'Input',
              name: 'Request ID Code Input',
              settings: {
                labelPosition: 'inner',
                labelValue: 'Request ID',
                name: inputNames.REQUEST_ID,
                required: true,
                border: {
                  borderWidth: 1,
                  borderColor: '#c7c7c7',
                  borderTopLeftRadius: 4,
                  borderTopRightRadius: 4,
                  borderBottomLeftRadius: 4,
                  borderBottomRightRadius: 4,
                  borderStyle: 'solid'
                }
              },
              children: []
            }]
          }, {
            type: 'Row',
            name: 'SSN/Number Row',
            settings: {
              margin: noMargins(),
              padding: noPaddings(),
              width: {
                type: '%',
                value: 70
              },
              align: 'space-between'
            },
            children: [{
              type: 'Column',
              name: 'Phone Input Column',
              settings: {
                margin: {
                  marginBottom: 20
                },
                padding: noPaddings(),
                width: {
                  value: 47,
                  type: '%'
                }
              },
              children: [{
                type: 'Input',
                name: 'Phone Input',
                settings: {
                  labelPosition: 'inner',
                  labelValue: 'Phone Number',
                  name: inputNames.PHONE,
                  required: true,
                  border: {
                    borderWidth: 1,
                    borderColor: '#c7c7c7',
                    borderTopLeftRadius: 4,
                    borderTopRightRadius: 4,
                    borderBottomLeftRadius: 4,
                    borderBottomRightRadius: 4,
                    borderStyle: 'solid'
                  }
                },
                children: []
              }]
            }, {
              type: 'Column',
              name: 'SSN Input Column',
              settings: {
                margin: {
                  marginBottom: 20
                },
                padding: noPaddings(),
                width: {
                  value: 47,
                  type: '%'
                }
              },
              children: [{
                type: 'Input',
                name: 'SSN Input',
                settings: {
                  labelPosition: 'inner',
                  labelValue: 'Last 4 of SSN',
                  name: 'ssn',
                  required: true,
                  border: {
                    borderWidth: 1,
                    borderColor: '#c7c7c7',
                    borderTopLeftRadius: 4,
                    borderTopRightRadius: 4,
                    borderBottomLeftRadius: 4,
                    borderBottomRightRadius: 4,
                    borderStyle: 'solid'
                  }
                },
                children: []
              }]
            }]
          }]
        }]
      }]
    }, {
      type: 'Row',
      name: 'Submit Row',
      settings: {
        padding: noPaddings(),
        margin: noMargins(),
        width: {
          value: 100,
          type: '%'
        },
        align: 'center'
      },
      children: [{
        type: 'SubmitButton',
        name: 'Submit Button',
        settings: {
          text: 'Submit',
          width: {
            value: 200,
            type: 'px'
          },
          margin: {
            marginBottom: 10
          }
        },
        children: []
      }]
    }]
  }]
};
const oneTimeCodeView = {
  type: 'OneTimeCodeView',
  name: 'One-time Code View',
  id: dsarRetrievalViews.ONE_TIME_CODE,
  settings: {
    align: 'center'
  },
  children: [{
    type: 'Column',
    name: 'Form Column',
    settings: {
      width: {
        value: 50,
        type: '%'
      },
      height: {
        value: 100,
        type: '%'
      },
      margin: noMargins(),
      padding: noPaddings()
    },
    children: [{
      type: 'Row',
      name: 'Header Row',
      settings: {
        align: 'center',
        vertical: 'center',
        width: fullWidthOrHeight(),
        margin: {
          marginBottom: 20
        },
        padding: noPaddings()
      },
      children: [{
        type: 'Text',
        name: 'Small Header',
        settings: {
          text: 'See My Data Request',
          margin: {
            marginTop: 10,
            marginBottom: 10
          },
          border: {
            borderWidth: 1,
            borderColor: 'rgba(134, 134, 134, 0.33)',
            borderStyle: 'solid',
            borderTop: 'none',
            borderLeft: 'none',
            borderRight: 'none'
          },
          font: {
            fontSize: 12,
            fontWeight: '400',
            color: '#868686',
            fontFamily: 'arial, helvetica, sans-serif'
          },
          width: fullWidthOrHeight(),
          padding: {
            paddingBottom: 5
          }
        },
        children: []
      }]
    }, {
      type: 'Row',
      name: 'Brand Image Row',
      settings: {
        padding: noPaddings(),
        margin: {
          marginBottom: 40
        },
        width: {
          value: 100,
          type: '%'
        },
        align: 'center'
      },
      children: [{
        type: 'Image',
        name: 'Brand Image',
        settings: {
          height: {
            value: 90,
            type: 'px'
          }
        },
        children: []
      }]
    }, {
      type: 'Text',
      name: 'Header',
      settings: {
        margin: {
          marginTop: 10,
          marginBottom: 10
        },
        padding: noPaddings(),
        text: 'Enter Code',
        font: {
          fontSize: 21,
          fontWeight: '400',
          color: '#000000',
          fontFamily: 'arial, helvetica, sans-serif'
        },
        align: 'center',
        margin: {
          marginBottom: 10
        },
        width: {
          value: 100,
          type: '%'
        }
      },
      children: []
    }, {
      type: 'Row',
      name: 'Form Row',
      settings: {
        padding: noPaddings(),
        margin: noMargins(),
        width: {
          type: '%',
          value: 100
        },
        align: 'center'
      },
      children: [{
        type: 'Column',
        name: 'Form Column',
        settings: {
          padding: noPaddings(),
          align: 'center',
          vertical: 'center',
          margin: {
            marginBottom: 45
          }
        },
        children: [{
          type: 'Text',
          name: 'Phone Label',
          settings: {
            text: 'Phone Number',
            margin: {
              marginBottom: 0
            },
            padding: {
              paddingBottom: 0
            },
            font: {
              fontSize: 12,
              fontWeight: '400',
              fontFamily: 'arial, helvetica, sans-serif',
              color: 'rgba(0, 0, 0, 0.6)'
            }
          },
          children: []
        }, {
          type: 'Text',
          id: 'phone-value',
          name: 'Phone Value',
          settings: {
            text: '888 888 8888',
            margin: {
              marginTop: 0
            },
            padding: {
              paddingTop: 0
            },
            font: {
              fontSize: 12,
              fontWeight: '400',
              fontFamily: 'arial, helvetica, sans-serif',
              color: 'rgba(0, 0, 0, 0.8)'
            }
          },
          children: []
        }, {
          type: 'Text',
          name: 'Last 4 Label',
          settings: {
            text: 'Last 4 digits of your SSN',
            margin: {
              marginBottom: 0
            },
            padding: {
              paddingBottom: 0
            },
            font: {
              fontSize: 12,
              fontWeight: '400',
              fontFamily: 'arial, helvetica, sans-serif',
              color: 'rgba(0, 0, 0, 0.6)'
            }
          },
          children: []
        }, {
          id: 'ssn-value',
          type: 'Text',
          name: 'Last 4 Value',
          settings: {
            text: '2345',
            margin: {
              marginTop: 0
            },
            padding: {
              paddingTop: 0
            },
            font: {
              fontSize: 12,
              fontWeight: '400',
              fontFamily: 'arial, helvetica, sans-serif',
              color: 'rgba(0, 0, 0, 0.8)'
            }
          },
          children: []
        }, {
          type: 'ErrorBlock',
          name: 'Form errors block',
          children: [],
          settings: {
            listItems: [],
            containerBackground: 'none',
            bulletType: 'none',
            ulFont: {
              fontSize: 12,
              fontWeight: '400',
              color: 'red',
              fontFamily: 'arial, helvetica, sans-serif'
            },
            ulPadding: noPaddings(),
            containerPadding: noPaddings(),
            containerAlign: 'center'
          }
        }, {
          type: 'Row',
          name: 'Row Input',
          settings: {
            margin: noMargins(),
            padding: noPaddings(),
            width: {
              value: 30,
              type: '%'
            }
          },
          children: [{
            type: 'Input',
            name: 'Code Input',
            settings: {
              name: inputNames.MFA,
              labelValue: 'Code',
              labelPosition: 'inner',
              required: true,
              border: {
                borderWidth: 1,
                borderColor: '#c7c7c7',
                borderTopLeftRadius: 4,
                borderTopRightRadius: 4,
                borderBottomLeftRadius: 4,
                borderBottomRightRadius: 4,
                borderStyle: 'solid'
              },
              margin: {
                marginBottom: 5
              }
            },
            children: []
          }]
        }, {
          type: 'Row',
          name: 'Resend Code Button Row',
          settings: {
            padding: noPaddings(),
            margin: noMargins(),
            width: {
              type: '%',
              value: 100
            },
            align: 'center'
          },
          children: [{
            type: 'CustomButton',
            name: 'Resend Code Button',
            settings: {
              onClickName: 'resendCode',
              text: 'Resend Code',
              margin: noMargins(),
              width: {
                type: 'px',
                value: 100
              },
              padding: {
                paddingLeft: 8,
                paddingRight: 8,
                paddingTop: 5,
                paddingBottom: 5
              },
              font: {
                fontSize: 12,
                fontWeight: '400',
                color: '#1890ff',
                fontFamily: 'arial, helvetica, sans-serif'
              },
              background: ''
            },
            children: []
          }]
        }]
      }]
    }, {
      type: 'Row',
      name: 'Submit Row',
      settings: {
        padding: noPaddings(),
        margin: noMargins(),
        width: {
          value: 100,
          type: '%'
        },
        align: 'center'
      },
      children: [{
        type: 'SubmitButton',
        name: 'Submit Button',
        settings: {
          text: 'Submit',
          width: {
            value: 200,
            type: 'px'
          },
          margin: noMargins()
        },
        children: []
      }]
    }]
  }]
};
const codeSuccessView = {
  type: 'CodeSuccessView',
  name: 'Code Success View',
  id: dsarRetrievalViews.CODE_SUCCESS,
  settings: {
    align: 'center'
  },
  children: [{
    type: 'Column',
    name: 'Form Column',
    settings: {
      width: {
        value: 50,
        type: '%'
      },
      height: {
        value: 100,
        type: '%'
      },
      margin: noMargins(),
      padding: noPaddings()
    },
    children: [{
      type: 'Row',
      name: 'Header Row',
      settings: {
        align: 'center',
        vertical: 'center',
        width: fullWidthOrHeight(),
        margin: {
          marginBottom: 20
        },
        padding: noPaddings()
      },
      children: [{
        type: 'Text',
        name: 'Small Header',
        settings: {
          text: 'See My Data Request',
          margin: {
            marginTop: 10,
            marginBottom: 10
          },
          border: {
            borderWidth: 1,
            borderColor: 'rgba(134, 134, 134, 0.33)',
            borderStyle: 'solid',
            borderTop: 'none',
            borderLeft: 'none',
            borderRight: 'none'
          },
          font: {
            fontSize: 12,
            fontWeight: '400',
            color: '#868686',
            fontFamily: 'arial, helvetica, sans-serif'
          },
          width: fullWidthOrHeight(),
          padding: {
            paddingBottom: 5
          }
        },
        children: []
      }]
    }, {
      type: 'Row',
      name: 'Brand Image Row',
      settings: {
        padding: noPaddings(),
        margin: {
          marginBottom: 40
        },
        width: {
          value: 100,
          type: '%'
        },
        align: 'center'
      },
      children: [{
        type: 'Image',
        name: 'Brand Image',
        settings: {
          height: {
            value: 90,
            type: 'px'
          }
        },
        children: []
      }]
    }, {
      type: 'Text',
      name: 'Header',
      settings: {
        margin: {
          marginTop: 10,
          marginBottom: 10
        },
        padding: noPaddings(),
        text: 'Code Verified!',
        font: {
          fontSize: 21,
          fontWeight: '600',
          color: '#000000',
          fontFamily: 'arial, helvetica, sans-serif'
        },
        align: 'center',
        margin: {
          marginBottom: 10
        },
        width: {
          value: 100,
          type: '%'
        }
      },
      children: []
    }, {
      type: 'Text',
      name: 'Description',
      settings: {
        margin: {
          marginTop: 10,
          marginBottom: 200
        },
        padding: noPaddings(),
        text: 'Your download should begin shortly...',
        font: {
          fontSize: 14,
          fontWeight: '400',
          color: '#000000',
          fontFamily: 'arial, helvetica, sans-serif',
          color: 'rgba(0, 0, 0, 0.8)'
        },
        align: 'center',
        margin: {
          marginBottom: 10
        },
        width: {
          value: 100,
          type: '%'
        }
      },
      children: []
    }]
  }]
};
const requestPendingView = {
  type: 'RequestPendingView',
  name: 'Request Pending View',
  id: dsarRetrievalViews.REQUEST_PENDING,
  settings: {
    align: 'center'
  },
  children: [{
    type: 'Column',
    name: 'Form Column',
    settings: {
      width: {
        value: 50,
        type: '%'
      },
      height: {
        value: 100,
        type: '%'
      },
      margin: noMargins(),
      padding: noPaddings()
    },
    children: [{
      type: 'Row',
      name: 'Header Row',
      settings: {
        align: 'center',
        vertical: 'center',
        width: fullWidthOrHeight(),
        margin: {
          marginBottom: 20
        },
        padding: noPaddings()
      },
      children: [{
        type: 'Text',
        name: 'Small Header',
        settings: {
          text: 'See My Data Request',
          margin: {
            marginTop: 10,
            marginBottom: 10
          },
          border: {
            borderWidth: 1,
            borderColor: 'rgba(134, 134, 134, 0.33)',
            borderStyle: 'solid',
            borderTop: 'none',
            borderLeft: 'none',
            borderRight: 'none'
          },
          font: {
            fontSize: 12,
            fontWeight: '400',
            color: '#868686',
            fontFamily: 'arial, helvetica, sans-serif'
          },
          width: fullWidthOrHeight(),
          padding: {
            paddingBottom: 5
          }
        },
        children: []
      }]
    }, {
      type: 'Row',
      name: 'Brand Image Row',
      settings: {
        padding: noPaddings(),
        margin: {
          marginBottom: 40
        },
        width: {
          value: 100,
          type: '%'
        },
        align: 'center'
      },
      children: [{
        type: 'Image',
        name: 'Brand Image',
        settings: {
          height: {
            value: 90,
            type: 'px'
          }
        },
        children: []
      }]
    }, {
      type: 'Text',
      name: 'Header',
      settings: {
        margin: {
          marginTop: 10,
          marginBottom: 10
        },
        padding: noPaddings(),
        text: 'Your Request in is Process!',
        font: {
          fontSize: 21,
          fontWeight: '600',
          color: '#000000',
          fontFamily: 'arial, helvetica, sans-serif'
        },
        align: 'center',
        margin: {
          marginBottom: 10
        },
        width: {
          value: 100,
          type: '%'
        }
      },
      children: []
    }, {
      type: 'Text',
      name: 'Header',
      settings: {
        margin: {
          marginTop: 10,
          marginBottom: 10
        },
        padding: noPaddings(),
        text: 'We are still in the process of completing the response to your request. You will receive an email when the request have been completed. You can expect a response by xx/xx/xxxx',
        font: {
          fontSize: 14,
          fontWeight: '400',
          color: '#000000',
          fontFamily: 'arial, helvetica, sans-serif',
          color: 'rgba(0, 0, 0, 0.8)'
        },
        align: 'center',
        margin: {
          marginBottom: 10
        },
        width: {
          value: 100,
          type: '%'
        }
      },
      children: []
    }]
  }]
};
export default [home, oneTimeCodeView, codeSuccessView, requestPendingView];